import React from "react";
import moment from "moment/min/moment-with-locales";
import { Redirect } from "react-router-dom";
moment.locale("pl");

const FishMarketDetailScreen = (props) => {
  if (!props.location.detail) return <Redirect to="/" />;
  const { detail } = props.location;
  const deliveryFromNow = moment(detail.time.seconds * 1000).fromNow();
  const deliveryExact = moment(detail.time.seconds * 1000).calendar();

  return (
    <div className="container main-container mb-3">
      <div className="row mt-1">
        <div className="col-md-12">
          <div className="card">
            {detail.fishType.img && (
              <div className="my-1 py-1">
                <img
                  className="rounded mx-auto d-block"
                  src={detail.fishType.img}
                  alt=""
                />
                <hr />
              </div>
            )}
            <div className="card-body">
              <h5 className="card-title">{detail.fishType.name} </h5>
              <p className="card-text">
                {detail.fisher && detail.fisher.firstName}{" "}
                {detail.fisher && detail.fisher.lastName}
              </p>
              {detail.fisher && detail.fisher.shipNo && (
                <p>Kuter: {detail.fisher.shipNo}</p>
              )}
              <p>
                Dostępność: {detail.amount}{" "}
                {detail.fishType.amount.kg ? `kg` : `sztuk`} {detail.price} zł/
                {detail.fishType.amount.kg ? `kg` : `sztukę`}
              </p>
              <p>
                Dostawa: {deliveryFromNow}
                {"\n"} (<span className="small">{deliveryExact}</span>)
              </p>
              <hr />
              <p>
                {detail.fisher &&
                  detail.fisher.phone &&
                  `Tel: ${detail.fisher.phone}`}
              </p>
              <p>
                {detail.fisher &&
                  detail.fisher.email &&
                  `Mail: ${detail.fisher.email}`}
              </p>
              <p>
                {detail.fisher && detail.fisher.lastName}{" "}
                {detail.fisher && detail.fisher.firstName}{" "}
                {detail.fisher && detail.fisher.shipNo
                  ? `, kuter: ${detail.fisher.shipNo}`
                  : null}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FishMarketDetailScreen;



// WEBPACK FOOTER //
// ./src/screens/MainPage/FishMarketDetailScreen.js